export default {
   API: 'simulacro.ucsp.edu.pe/back',
   HTTP_API: 'https:',
}
